// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Contacts_Filled_Corner2_Rounded = createSinglePathSVG({
  path: 'M15 10.5a2.25 2.25 0 1 1-2.25-2.25A2.25 2.25 0 0 1 15 10.5Zm6-6.75v16.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V18H3a.75.75 0 0 1 0-1.5h1.5v-3.75H3a.75.75 0 0 1 0-1.5h1.5V7.5H3A.75.75 0 0 1 3 6h1.5V3.75A1.5 1.5 0 0 1 6 2.25h13.5a1.5 1.5 0 0 1 1.5 1.5ZM17.85 15.3a6.36 6.36 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0A6.36 6.36 0 0 0 7.65 15.3a.75.75 0 1 0 1.2.9 4.875 4.875 0 0 1 7.8 0 .75.75 0 1 0 1.2-.9Z',
  viewBox: '0 0 24 24',
  glyph: 'Contacts_Filled_Corner2_Rounded',
})

export const Contacts_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M7.8 16.35a.75.75 0 0 0 1.05-.15 4.875 4.875 0 0 1 7.8 0 .75.75 0 1 0 1.2-.9 6.36 6.36 0 0 0-2.569-2.033 3.75 3.75 0 1 0-5.057 0A6.36 6.36 0 0 0 7.65 15.3a.75.75 0 0 0 .15 1.05Zm2.7-5.85a2.25 2.25 0 1 1 2.25 2.25 2.25 2.25 0 0 1-2.25-2.25Zm9-8.25H6a1.5 1.5 0 0 0-1.5 1.5V6H3a.75.75 0 0 0 0 1.5h1.5v3.75H3a.75.75 0 0 0 0 1.5h1.5v3.75H3A.75.75 0 0 0 3 18h1.5v2.25a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5V3.75a1.5 1.5 0 0 0-1.5-1.5Zm0 18H6V3.75h13.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Contacts_Stroke2_Corner2_Rounded',
})
